import React, { useEffect, useState } from 'react';
import Layout from './Layout';
import { executeGet } from '@/lib/amplifyRestClient';

interface FacilityIdInputProps {
  onConfirm: (facilityData: { facilityId: string; facilityName: string }) => void;
}

type Facility = {
  id: string;
  facility_name: string;
};

type APIResponse = {
  facilities?: Facility[];
};

const FacilityIdInput: React.FC<FacilityIdInputProps> = ({ onConfirm }) => {
  const [inputId, setInputId] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 初期値として localStorage の値を設定
    const savedFacilityId = localStorage.getItem('facilityId');
    if (savedFacilityId) {
      setInputId(savedFacilityId);
    }
  }, []);

  const handleSubmit = async () => {
    setError(null);

    if (!inputId.trim()) {
      setError('施設IDを入力してください。');
      return;
    }

    setLoading(true);

    const response = await executeGet({
      apiName: 'medirecoWebApi',
      path: '/get-facility-list'
    });

    if (!response.result) {
      setError('予期せぬエラーが発生しました。');
      setLoading(false);
      return;
    }

    const facilityList = response.data as APIResponse;

    if (facilityList.facilities && Array.isArray(facilityList.facilities)) {
      const matchingFacility = facilityList.facilities.find(
        (facility: { id: string; facility_name: string }) => facility.id === inputId
      );

      if (matchingFacility) {
        onConfirm({
          facilityId: matchingFacility.id,
          facilityName: matchingFacility.facility_name
        });
      } else {
        setError('入力された施設IDに一致する施設が見つかりません。');
      }
    } else {
      setError('施設情報が正しく取得できませんでした。');
    }
    setLoading(false);
  };

  return (
    <Layout flowName="">
      <div className="text-center">
        <p className="text-2xl sm:text-3xl font-bold text-gray-700 my-8">ご利用には施設IDをご入力ください。</p>
        <p className="text-sm sm:text-base font-medium text-gray-500 mb-8">
          こちらの画面はスタッフ専用です。
          <br />
          お客さまは操作を行わず、スタッフにお声がけください。
        </p>
      </div>
      <div className="mb-8 w-full sm:w-1/2 mx-auto">
        <label className="block text-sm font-medium text-gray-700 mb-2">施設ID</label>
        <input
          type="text"
          value={inputId}
          onChange={(e) => setInputId(e.target.value)}
          className="border border-gray-300 rounded-md px-4 py-2 w-full text-gray-700"
          placeholder="施設IDを入力してください"
        />
      </div>
      {error && <p className="text-red-500 text-center">{error}</p>}
      <button
        onClick={handleSubmit}
        disabled={loading}
        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded w-full sm:w-1/2 mx-auto block"
      >
        {loading ? '読み込み中...' : '確認画面へ進む'}
      </button>
    </Layout>
  );
};

export default FacilityIdInput;
